import Link from '@/gf/components/LinkOld'
import Page from '@/gf/components/Page'
import Frame from '../../components/Frame'
import Urls from '../../modules/Urls'

// The request query answers null when the request is not shared with any of the user's stores
// (GEA-10861), so say that instead of drawing a blank page.
const Unavailable = ({ storeName, failed }: { storeName: string; failed: boolean }) => (
  <Frame>
    <Page
      className="pt-4 lg:pt-8"
      title={failed ? 'Request could not load' : 'Request not available'}
    >
      <div className="max-w-prose flex flex-col gap-y-3 text-base text-gray-900">
        {failed ? (
          <p>Something went wrong while loading this request. Refresh the page to try again.</p>
        ) : (
          <>
            <p>
              This request was not found, or it was not sent to your store,{' '}
              <span className="font-medium">{storeName}</span>.
            </p>
            <p>
              If the customer sent it to another store in your company, ask them to add your store
              to the request, or ask a user of that store to open it.
            </p>
          </>
        )}
        <p>
          <Link to={Urls.requestForQuotes()}>Back to requests</Link>
        </p>
      </div>
    </Page>
  </Frame>
)

export default Unavailable
